export const CLINICIANS_AGENT_USERNAME = 'fountaincliniciansagent';

/** Persisted UX: true = Thinking (tools loop on), false = Fast. */
export const CLINICIAN_CHAT_TOOLS_LOOP_STORAGE_KEY =
  'qa-agent-clinician-chat-tools-loop-enabled';
export const POPULATION_AGENT_USERNAME = 'fountainclinicanpopulationagent';
export const MEMBERS_AGENT_USERNAME = 'fountainmembersagent';
export const SUMMARY_CODE = 'zora-member-chat-summary';
export const TOPIC_CODE = 'zora-member-chat-topic';
export const OLDEST_POST_DATE =
  'http://lifeomic.com/fhir/fountain-life-communication-oldest-post-date';

export const CitationTypes = ['MedicalResult', 'DocumentReference'] as const;
export type CitationType = (typeof CitationTypes)[number];

interface DocumentTypeMetadata {
  name: string;
}

export const DocumentTypes = [
  'lung-ct',
  'dexa',
  'executive-summary',
  'full-body-mri',
  'ekg',
  'balance-tracker',
  'grip-strength',
  'olfactory',
  'prevencio',
  'cardio-wave',
  'grail-multicancer',
  'brainkey',
  'polygenic-risk-scores',
  'amra',
  'dari-motion',
  'drowzle',
  'truage',
  'kbmo',
  'dutch',
  'genova-nutreval',
  'proteomics',
  'nebula',
  'cns-vitals',
  'retinal-scan',
  'radiology-key-images',
] as const;
export type DocumentType = (typeof DocumentTypes)[number];

// largely adapted from the LLM metadata for the vector querying
// but are specifically for clinicians to reference the document types
// at some point we could change the names to be intl messages if necessary, but
// all of the AI stuff is in English and we don't have a current need for intl
export const DOCUMENT_TYPE_METADATAS: Record<
  DocumentType,
  DocumentTypeMetadata
> = {
  'lung-ct': {
    name: 'Lung CT',
  },
  dexa: {
    name: 'DEXA',
  },
  'executive-summary': {
    name: 'Executive Summary',
  },
  'full-body-mri': {
    name: 'Full Body MRI',
  },
  ekg: {
    name: 'EKG',
  },
  'balance-tracker': {
    name: 'Balance Tracker',
  },
  'grip-strength': {
    name: 'Grip Strength',
  },
  olfactory: {
    name: 'Olfactory',
  },
  prevencio: {
    name: 'Prevencio',
  },
  'cardio-wave': {
    name: 'Cardio Wave',
  },
  'grail-multicancer': {
    name: 'Grail',
  },
  brainkey: {
    name: 'BrainKey',
  },
  'polygenic-risk-scores': {
    name: 'Polygenic Risk Scores',
  },
  amra: {
    name: 'AMRA',
  },
  'dari-motion': {
    name: 'DARI Motion',
  },
  drowzle: {
    name: 'Drowzle',
  },
  truage: {
    name: 'TruAge',
  },
  kbmo: {
    name: 'KBMO',
  },
  dutch: {
    name: 'DUTCH',
  },
  'genova-nutreval': {
    name: 'Genova NutrEval',
  },
  proteomics: {
    name: 'Proteomics',
  },
  nebula: {
    name: 'Nebula',
  },
  'cns-vitals': {
    name: 'CNS Vitals',
  },
  'retinal-scan': {
    name: 'AEye',
  },
  'radiology-key-images': {
    name: 'Key Radiology Images',
  },
};
